import { AlertTriangle, AlertCircle, Check, Zap } from "lucide-react";

const VERDICTS = {
  aligned:           { label: "OUTLETS ALIGNED",   color: "bg-emerald-700 text-emerald-50",   Icon: Check },
  mild_divergence:   { label: "MILD DIVERGENCE",   color: "bg-amber-600 text-amber-50",       Icon: AlertCircle },
  strong_divergence: { label: "OUTLETS DISAGREE",  color: "bg-[#E60000] text-stone-50",       Icon: AlertTriangle },
  contradictory:     { label: "CONTRADICTORY",     color: "bg-stone-900 text-[#E60000]",      Icon: Zap },
};

export default function DivergenceBadge({ divergence, size = "sm" }) {
  if (!divergence) return null;
  const v = VERDICTS[divergence.verdict] || VERDICTS.aligned;
  const Icon = v.Icon;
  const sizeCls = size === "lg"
    ? "text-xs px-3 py-1.5"
    : "text-[10px] px-2 py-1";
  return (
    <span
      data-testid="divergence-badge"
      className={`inline-flex items-center gap-1 font-mono-head uppercase tracking-[0.2em] ${v.color} ${sizeCls}`}
      title={`Divergence score: ${(divergence.divergence_score * 100).toFixed(0)}%`}
    >
      <Icon className="w-3 h-3" /> {v.label} · {(divergence.divergence_score * 100).toFixed(0)}%
    </span>
  );
}
